module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0072.jpg?v=d65f9a89";